import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaExchangeAlt, FaClipboardList, FaSearch } from 'react-icons/fa';
import './Home.css'

const Home = () => {

    const session = JSON.parse(localStorage.getItem("odoo_session"));
    const username = session?.username;

    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    const internalTransfers = () => {;
        navigate('/originlocation')
    };

    const InventoryTaking = () => {
        navigate('/locationscan')
    };

    const packageInquiry = () => {
        navigate('/packageinquiry')
    };


    return (
        <div className="home">
            <header className="home_header">
                <h1>Odoo</h1>
                <p>Bienvenido {username}</p>
            </header>

            <div className="home_buttons">
                <button
                 onClick={internalTransfers}
                 className="home__btn home__btn--primary"
                >
                    Transferencia interna
                    <FaExchangeAlt className="btn_icon" />
                </button>

                <button
                 onClick={InventoryTaking}
                 className="home__btn home__btn--primary"
                > 
                    Toma de inventario
                    <FaClipboardList className="btn_icon" />
                </button>

                <button
                 onClick={packageInquiry}
                 className="home__btn home__btn--primary"
                >   
                    Consultar Paquete
                    <FaSearch className="btn_icon" />
                </button>

            </div>
        </div>
    );
};

export default Home;
